/* eslint-disable no-inline-styles/no-inline-styles */
import { Stack, Text } from "@fluentui/react";
import { useTheme } from "cayo.ui";
import { FC } from "react";
import { useIntl } from "react-intl";
import ConfigurationTaskIcon from "./ConfigurationTaskIcon";
import ConfigureButton from "./ConfigureButton";
import messages from "./messages";

export type ConfigurationTask = {
  icon: string;
  text: string;
  helpLink: string;
  onClick: () => void;
  completed?: boolean;
  disableIfConfigured?: boolean;
  disabled?: boolean;
  hidden?: boolean;
};

type ConfigurationTasksProps = { buttonWidth: number; items: ConfigurationTask[] };

const ConfigurationTasks: FC<ConfigurationTasksProps> = ({ items, buttonWidth }) => {
  const { cayoTheme } = useTheme();
  const intl = useIntl();

  return (
    <Stack
      horizontal={true}
      horizontalAlign="space-between"
      styles={{ root: { width: "100%", position: "relative" } }}
    >
      {items
        .filter((item) => !item.hidden)
        .map((item, i) => {
          return (
            <>
              <Stack key={i} horizontal={false} horizontalAlign="center">
                <ConfigureButton
                  {...item}
                  disabled={item.disabled || (item.completed && item.disableIfConfigured)}
                  width={buttonWidth}
                  style={{ marginBottom: 20 }}
                />

                <ConfigurationTaskIcon
                  completed={item.completed}
                  disabled={item.disabled}
                  style={{
                    backgroundColor: cayoTheme.brandColors.primaryBackground,
                    zIndex: 1,
                    padding: "0 4px",
                  }}
                />
                <Text variant="small">
                  {intl.formatMessage(messages.stepCount, { index: i + 1 })}
                </Text>
              </Stack>
            </>
          );
        })}
    </Stack>
  );
};

export default ConfigurationTasks;
